export const PASS_ENTRY_COUNTS = {
    single: 1,
    ten_pack: 10,
    monthly: null, // unlimited
    annual: null, // unlimited
};
export const PASS_LABELS_IS = {
    single: 'Stakur miði',
    ten_pack: '10 miða kort',
    monthly: 'Mánaðarkort',
    annual: 'Árskort',
};
export const ACCESS_TOKEN_EXPIRY = '15m';
export const REFRESH_TOKEN_EXPIRY_DAYS = 30;
export const REVERSAL_WINDOW_MINUTES = 5;
export const CHECKIN_DISPLAY_SECONDS = 10;
export const VERIFICATION_CODE_ACTIVE_WINDOW_SECONDS = 15;
export const VERIFICATION_CODE_MAX = 100;
export const POOL_CHECKIN_COOLDOWN_SECONDS = 60;
//# sourceMappingURL=pass-config.js.map